import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "hidden": "Pills-hidden_2zW_s",
  "disabled": "Pills-disabled_2SuIv"
};
function PillsPanel({
  label,
  hidden,
  className,
  children,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    tagName: "section",
    className: clsx({
      [styles.hidden]: hidden
    }, className),
    ...extraProps,
    children: children
  });
}
export default PillsPanel;